"use strict";
(function (global) {

  /**
  * Редактор для ячейки с реквизитом "Ссылка на документ".  
  * @class WebAccess.components.dataViews.gridPlugins._editors.DocumentEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor
  * @since 5.5.0.1000
  */
  global.DocumentEditor = global.BaseObjectSelectEditor.extend({
    _renderer: null,
    _wrapper: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает рендерер.
     */
    _createRenderer: function () {
      return new WebAccess.components.forms.requisites.DocumentSelect();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает объект-обертку над контролом реквизита, с необходимыми методами типа getValue
     */
    _createWrapper: function (parentCurrent) {
      var me = this;
      return new WA.CMP.wrappers.form.requisites.Document(me._column.id, me.id, parentCurrent.form);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

})(window.WA.components.dataViews.gridPlugins._editors)